export const LOAD_MORE_ITEMS = "LOAD_MORE_ITEMS";
export const SEARCH_TEXT = "SEARCH_TEXT";
export const SET_LOADING = "SET_LOADING";
export const SET_APPDRAWER = "SET_APPDRAWER";
export const SEARCH_TEXTI = "SEARCH_TEXTI";
export const SET_LOADINGI = "SET_LOADINGI";
export const SET_FOCUS = "SET_FOCUS";
export const ADD_TOGGLE_MODE = "ADD_TOGGLE_MODE";
export const SET_AMT_FOCUS = " SET_AMT_FOCUS";
export const SET_MOBILE_POS = "SET_MOBILE_POS";
export const BARCODE_FOCUS = "BARCODE_FOCUS";
export const ORDER_TEXT = "ORDER_TEXT";
export const RETURN_TEXT = "RETURN_TEXT";
export const SET_DEVICE_TYPE = "SET_DEVICE_TYPE";
export const ORDER_STATUS = "ORDER_STATUS";
export const ORDER_ID = "ORDER_ID";
export const SCAN_END = "SCAN_END";
export const SELECT_BATCH_STAT = "SELECT_BATCH_STAT";
export const CUSTOMER_TEXT = "CUSTOMER_TEXT";
export const SEARCH_OPEN = "SEARCH_OPEN";
export const RENDER_TYPE = "RENDER_TYPE";
export const SET_BOARD_ITEM = "SET_BOARD_ITEM";
export const SET_ODS_NEW = "SET_ODS_NEW";
export const SET_ODS_CART = "SET_ODS_CART";
export const RETURNED_ITEMS = "RETURNED_ITEMS";
export const SET_ODS_NOTIF = "SET_ODS_NOTIF";
export const ORDER_AGG_TAB = "ORDER_AGG_TAB";
export const ODS_TEXT = "ODS_TEXT";

export const searchTextRes = (payload) => {
  return { type: SEARCH_TEXT, payload };
};

export const setLoading = (payload) => {
  return { type: SET_LOADING, payload };
};

export const setPageNum = (payload) => {
  return { type: LOAD_MORE_ITEMS, payload };
};

export const setAppDrawer = (payload) => {
  return { type: SET_APPDRAWER, payload };
};

export const searchTextRespaymnet = (payload) => {
  return { type: SEARCH_TEXTI, payload };
};

export const setLoadingpaymnet = (payload) => {
  return { type: SET_LOADINGI, payload };
};
export const setFocus = (payload) => {
  return { type: SET_FOCUS, payload };
};
export const addtoggleMode = (payload) => {
  return { type: ADD_TOGGLE_MODE, payload };
};

export const setAmtFocus = (payload) => {
  return { type: SET_AMT_FOCUS, payload };
};

export const setMobilePos = (payload) => {
  return { type: SET_MOBILE_POS, payload };
};

export const setDeviceType = (payload) => {
  return { type: SET_DEVICE_TYPE, payload };
};

export const focusBarcode = (payload) => {
  return { type: BARCODE_FOCUS, payload };
};

export const orderFilter = (payload) => {
  return { type: ORDER_TEXT, payload };
};

export const returnFilter = (payload) => {
  return { type: RETURN_TEXT, payload };
};

export const odsFilter = (payload) => {
  return { type: ODS_TEXT, payload };
};

export const orderDetailsFilter = (payload) => {
  return { type: ORDER_STATUS, payload };
};

export const customerFilter = (payload) => {
  return { type: CUSTOMER_TEXT, payload };
};

export const orderId = (payload) => {
  return { type: ORDER_ID, payload };
};

export const scanEnd = (payload) => {
  return { type: SCAN_END, payload };
};

export const selectBatchStat = (payload) => {
  return { type: SELECT_BATCH_STAT, payload };
};

export const openProductDetailsSearch = (payload) => {
  return { type: SEARCH_OPEN, payload };
};

export const allProductsRenderType = (payload) => {
  return { type: RENDER_TYPE, payload };
};

export const setBoardItem = (payload) => {
  return { type: SET_BOARD_ITEM, payload };
};

export const setNewOds = (payload) => {
  return { type: SET_ODS_NEW, payload };
};

export const setOdsCart = (payload) => {
  return { type: SET_ODS_CART, payload };
};

export const setReturnedItems = (payload) => {
  return { type: RETURNED_ITEMS, payload };
};

export const setOdsNotif = (payload) => {
  return { type: SET_ODS_NOTIF, payload };
};

// Tracks which OrdersPage tab is active so the global search can know when
// "Order History" is on screen (the tab lives in local component state).
export const setOrderAggTab = (payload) => {
  return { type: ORDER_AGG_TAB, payload };
};
